import React, { ChangeEvent, FC, isValidElement } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import More from '@material-ui/icons/MoreHoriz';

const LongMenu: FC = ({ children }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const elements = React.Children.map(children, (child) => {
    if (isValidElement(child)) {
      return React.cloneElement<any>(child, {
        onClick: (event: ChangeEvent<HTMLInputElement>) => {
          child.props.onClick?.(event);
          handleClose();
        },
      });
    } else {
      return child;
    }
  });

  return (
    <div>
      <IconButton aria-label="more" aria-controls="long-menu" aria-haspopup="true" onClick={handleClick}>
        <More />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        disableScrollLock
      >
        {elements}
      </Menu>
    </div>
  );
};

export default LongMenu;
